//
//
//
//
//
//
//
//
//

import { Loading } from 'vux'
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  data () {
    return {
      transName: 'push',
      transMode: ''
    }
  },
  computed: {
    ...mapGetters(['loading', 'invalidResponse'])
  },
  created () {
    // 获取当前用户信息
    this.$store.dispatch('profile/fetchUserInfo')
  },
  watch: {
    invalidResponse (val, old) {
      const { code, msg } = val
      if (code === 100001) {
        this.$toast('未登录')
        this.$router.replace({ name: 'login' })
      }
      console.log(msg || '数据异常')
    },
    $route (to, from) {
      if (!from.name) {
        this.transName = 'fade'
        this.transMode = 'out-in'
        return
      }
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      const mode = to.query.mode
      if (mode === 'modal') {
        this.transName = 'modal'
        this.transMode = 'in-out'
      } else if (mode === 'dismiss') {
        this.transName = 'dismiss'
        this.transMode = 'in-out'
      } else if (mode === 'turn') {   // 翻转
        this.transName = 'turn'
        this.transMode = 'out-in'
      } else if (toDepth > fromDepth || mode === 'push') {
        this.transName = 'push'
        this.transMode = ''
      } else if (toDepth < fromDepth || mode === 'pop') {
        this.transName = 'pop'
        this.transMode = ''
      } else {
        this.transName = 'fade'
        this.transMode = 'out-in'
      }
    }
  },
  components: {
    Loading
  }
}
